module.exports = __webpack_public_path__ + "static/target-accounting-logo-056874fa348a28c219c9e14fa72000e5.png";